import { render, staticRenderFns } from "./TopCategories.vue?vue&type=template&id=4f9428f2"
import script from "./TopCategories.vue?vue&type=script&lang=js"
export * from "./TopCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports